export const AUTH_CONFIG = {
    domain: 'connect-testing.au.auth0.com',
    clientId: 'CB1d-Gjz_b54t_WQGx3eFscCn-0LlwEz',
    callbackUrl: 'https://powerful-dawn-74737.herokuapp.com/callback'
  }


// WEBPACK FOOTER //
// ./src/Auth/auth0-variables.js